import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module enter/enterobserver
 */
import Observer from '@ckeditor/ckeditor5-engine/src/view/observer/observer';
import DomEventData from '@ckeditor/ckeditor5-engine/src/view/observer/domeventdata';
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
/**
 * Enter observer introduces the {@link module:engine/view/document~Document#event:enter} event.
 *
 * @extends module:engine/view/observer/observer~Observer
 */

var EnterObserver = /*#__PURE__*/function (_Observer) {
  _inherits(EnterObserver, _Observer);

  var _super = _createSuper(EnterObserver);

  function EnterObserver(view) {
    var _this;

    _classCallCheck(this, EnterObserver);

    _this = _super.call(this, view);
    var doc = _this.document;
    doc.on('keydown', function (evt, data) {
      if (_this.isEnabled && data.keyCode == keyCodes.enter) {
        // Save the event object to check later if it was stopped or not.
        var event;
        doc.once('enter', function (evt) {
          return event = evt;
        }, {
          priority: 'highest'
        });
        doc.fire('enter', new DomEventData(doc, data.domEvent, {
          isSoft: data.shiftKey
        })); // Stop `keydown` event if `enter` event was stopped.
        // https://github.com/ckeditor/ckeditor5/issues/753

        if (event && event.stop.called) {
          evt.stop();
        }
      }
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(EnterObserver, [{
    key: "observe",
    value: function observe() {}
  }]);

  return EnterObserver;
}(Observer);
/**
 * Event fired when the user presses the <kbd>Enter</kbd> key.
 *
 * Note: This event is fired by the {@link module:enter/enterobserver~EnterObserver observer}
 * (usually registered by the {@link module:enter/enter~Enter Enter feature} and
 * {@link module:enter/shiftenter~ShiftEnter ShiftEnter feature}).
 *
 * @event module:engine/view/document~Document#event:enter
 * @param {module:engine/view/observer/domeventdata~DomEventData} data
 * @param {Boolean} data.isSoft Whether it's a soft enter (<kbd>Shift</kbd>+<kbd>Enter</kbd>) or hard enter (<kbd>Enter</kbd>).
 */


export { EnterObserver as default };